import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Medallion } from './Medallion';
export function GuaranteeSection() {
  return <section className="w-full bg-cream py-10 sm:py-12" aria-labelledby="guarantee-heading" data-id="element-71" data-mp="4vs0dxwxedqv">
      <div className="mx-auto max-w-3xl px-6" data-id="element-72" data-mp="9tl7qu9ytdsq">
        <div className="rounded-4xl border border-gold/35 bg-blush px-7 py-11 text-center sm:px-12" data-id="element-73" data-mp="etfxgui07xc7">
          <Medallion icon={ShieldCheckIcon} data-id="element-74" data-mp="jsiubrntyx93" />
          <h2 id="guarantee-heading" className="mt-5 font-display text-3xl leading-tight text-charcoal sm:text-4xl" data-id="element-75" data-mp="jrr7b58au7uf">
            7-Day Risk-Free Guarantee
          </h2>
          <p className="mx-auto mt-5 max-w-xl font-sans text-base leading-relaxed text-ash" data-id="element-76" data-mp="skcdlluqum2d">
            Open the library, explore the 7 bonuses, and use the material in
            your most demanding class this week. If it doesn’t deliver what we
            promise here, write to us within 7 days and we refund{' '}
            <span className="font-medium text-wine" data-id="element-77" data-mp="17j69my02sp5o">100% of your money</span>.
          </p>
          <p className="mx-auto mt-5 max-w-lg font-display text-xl italic leading-snug text-wine" data-id="element-78" data-mp="25sylav2h3mia">
            You risk nothing but the time it takes to open the first volume.
          </p>
        </div>
      </div>
    </section>;
}